<template>
  <div :class="{'wrapper-loading':adaptParent}" v-loading="loading">
   <div v-adapt-height="{ offsetTo, setHeight, listenUpdate: adaptHeightListenUpdate }"
       class="gj-table"
       :class="{
          // 'auto-height': hasPagination && adaptParent,
          // 'auto-height-slot': $slots.footer && adaptParent,
          // 'auto-height-all': $slots.footer && hasPagination && adaptParent,
          'error-column-height': errorColumn
       }"
       :style="{height: pTableHeight}">
    <!-- 暂时解决，不要删除 -->
    <div style="display: none;">{{ tableHeightChage }}</div>

    <!-- 表单 tab 标签，START -->
    <table-tab ref="tab" v-if="hasTab"
      :columns="columns"
      :slot-group="slotGroup"
      :gj-table="$refs.gjTable"
      >
      <template v-for="item in slotGroup" v-slot:[item]="props">
        <slot :name="item" v-bind="props"></slot>
      </template>
    </table-tab>
    <!-- 表单 tab 标签，END -->
    <!-- show-overflow 不可修改 会影响存在固定列下的渲染性能 -->
    <vxe-table
        round
        ref="gjTable"
        v-bind="$attrs"
        v-on="$listeners"
        :highlight-hover-row="highlightHoverRow"
        column-key
        :show-overflow="showOverflow"
        :show-header-overflow="showHeaderOverflow"
        :show-footer-overflow="showFooterOverflow"
        :tree-config="proxyTreeConfig"
        :span-method="proxySpanMethod"
        :row-class-name="proxyRowClassName"
        :data="tableData"
        :border="proxyBorder"
        :height="pVxeHeight"
        :max-height="tableMaxHeight"
        :class="[
          'gj-table--sortable',
          'gj-table--' + size,
          !hasPagination ? 'gj-table-no-pagination' : '',
          isMeaningless(data) || data.length === 0 ? 'gj-table-empty' : '',
          parentChildStructure ? 'gj-parent-child-table' : ''
        ]"
        :auto-resize="autoResize"
        :sync-resize="syncResize"
        :stripe="stripe"
        :scroll-y="scrollY"
        :show-footer="showSummary && data && data.length > 0"
        :footer-method="proxySummaryMethod"
        :checkbox-config="{checkMethod: checkMethod, showHeader: showAllCheckbox}"
        :sort-config="{trigger: 'cell', defaultSort: proxyDefaultSort, remote: remote}"
        :highlight-current-row="highlightCurrentRow"
        @checkbox-all="selectionChange"
        @checkbox-change="selectionChange"
        @cell-mouse-enter="cellMouseEnter"
        @cell-mouse-leave="cellMouseLeave"
        @current-change="currentChange"
        @scroll="handleTableScroll"
        style="width: 100%">

      <vxe-table-column
          v-if="parentChildTreeStructure"
          width="50px"
          align="center"
          fixed="left">
        <template v-slot:default="{row, $rowIndex}">
          <div v-if="row.$gjChildItemLength > 1"
               class="gj-table__row--expand-icon">
            <template v-if="row.$gjExpandState === gjExpandState.waitExpand">
              <i class="el-icon-arrow-right"
                 @click="parentChildExpandRow(true, row, $rowIndex)"></i>
            </template>
            <template v-if="row.$gjExpandState === gjExpandState.expanding">
              <i class="el-icon-loading"></i>
            </template>
            <template v-if="row.$gjExpandState === gjExpandState.expanded">
              <i class="el-icon-arrow-down"
                 @click="parentChildExpandRow(false, row, $rowIndex)"></i>
            </template>
          </div>
          <div v-else>-</div>
        </template>
      </vxe-table-column>
      <vxe-table-column
          v-if="expand && !expandLazyLoad"
          width="50px"
          type="expand"
          fixed="left"
          align="center">
        <template v-slot:content="{row, $rowIndex}">
          <template v-if="$scopedSlots.expand">
            <slot name="expand" :row="row" :expand-row="row" :expand-index="$rowIndex" :index="$rowIndex"></slot>
          </template>
          <template v-else>
            <vxe-table
              auto-resize
              v-bind="expandTableAttrs"
              :data="row.$gjExpandRowData"
              :show-header="false"
              :show-pagination="false"
              :border="'inner'">
            <vxe-table-column
                width="50px"
                fixed="left">
            </vxe-table-column>
            <vxe-table-column
                v-if="expandSeizeSeat"
                width="50px"
                fixed="left">
            </vxe-table-column>
            <template v-for="(column, index) in columns">
              <vxe-table-column
                  v-if="show(column)"
                  :key="index"
                  v-bind="column">
                <template v-slot:default="{ $rowIndex, row }">
                  <!-- slot -->
                  <template v-if="decorated(column.field, 'slot')">
                    <slot :name="`expand:${originField(column.field)}`" :index="$rowIndex" :row="row"></slot>
                  </template>
                  <!-- prefix、suffix -->
                  <template v-else-if="column.prefix || column.suffix">
                    {{ row[column.field] | scale(column) | valConcat(row, column.prefix, column.suffix) | proxyDefaultShow(column.defaultShow) }}
                  </template>
                  <template v-else>
                    {{ (column.formatter || formatter)(row, column) }}
                  </template>
                </template>
              </vxe-table-column>
            </template>
          </vxe-table>
          </template>
        </template>
      </vxe-table-column>
      <vxe-table-column
          v-if="expand && expandLazyLoad"
          width="50px"
          fixed="left"
          align="center">
        <template v-slot:default="{row, $rowIndex}">
          <template v-if="row.$gjExpandRow">
            <template v-if="$scopedSlots.expand">
              <slot name="expand" :index="$rowIndex" :row="row" :expand-row="row.$gjExpandRowData"></slot>
            </template>
            <template v-else>
              <vxe-table
                  auto-resize
                  v-bind="expandTableAttrs"
                  :data="row.$gjExpandRowData"
                  :show-header="false"
                  :show-pagination="false"
                  :border="'inner'">
                <vxe-table-column
                    width="50px"
                    fixed="left">
                </vxe-table-column>
                <vxe-table-column
                    v-if="expandSeizeSeat"
                    width="50px"
                    fixed="left">
                </vxe-table-column>
                <template v-for="(column, index) in columns">
                  <vxe-table-column
                      v-if="show(column)"
                      :key="index"
                      v-bind="column">
                    <template v-slot:default="{ $rowIndex, row }">
                      <!-- slot -->
                      <template v-if="decorated(column.field, 'slot')">
                        <slot :name="`expand:${originField(column.field)}`" :index="$rowIndex" :row="row"></slot>
                      </template>
                      <!-- prefix、suffix -->
                      <template v-else-if="column.prefix || column.suffix">
                        {{ row[column.field] | scale(column) | valConcat(row, column.prefix, column.suffix) | proxyDefaultShow(column.defaultShow) }}
                      </template>
                      <template v-else>
                        {{ (column.formatter || formatter)(row, column) }}
                      </template>
                    </template>
                  </vxe-table-column>
                </template>
              </vxe-table>
            </template>
          </template>
          <template v-else>
            <div class="gj-table__row--expand-icon">
              <template v-if="row.$gjExpandState === gjExpandState.waitExpand">
                <i class="el-icon-arrow-right" @click="expandRow(true, row, $rowIndex)"></i>
              </template>
              <template v-if="row.$gjExpandState === gjExpandState.expanding">
                <i class="el-icon-loading"></i>
              </template>
              <template v-if="row.$gjExpandState === gjExpandState.expanded">
                <i class="el-icon-arrow-down" @click="expandRow(false, row, $rowIndex)"></i>
              </template>
            </div>
          </template>
        </template>
      </vxe-table-column>
      <vxe-table-column
          v-if="selection"
          type="checkbox"
          :selectable="selectable"
          align="center"
          fixed="left"
          width="50px">
      </vxe-table-column>
      <vxe-table-column
          v-if="index && !parentChildStructure"
          :title="indexText"
          type="seq"
          fixed="left"
          :tree-node="indexTreeNode"
          width="60px">
      </vxe-table-column>
      <template v-for="column in enhancedColumns">
        <vxe-table-colgroup
            v-if="column.ex.colgroup"
            :key="column.ex.id"
            v-bind="column">
          <template #header>
            <template v-if="column.required">
              <span class="required-icon">*</span>
            </template>
            <template v-if="column.ex.header.slot">
              <slot :name="column.ex.header.slotField"></slot>
            </template>
            <template v-else>
              <span>{{column.header}}</span>
            </template>
            <template v-if="column.help">
              <gj-help class="gj-help">
                {{column.help}}
              </gj-help>
            </template>
            <template v-if="column.helpHtml">
              <gj-help class="gj-help">
                <span v-html="column.helpHtml"></span>
              </gj-help>
            </template>
          </template>
          <template v-for="childColumn in column.ex.children">
            <vxe-table-column
                v-if="childColumn.ex.col"
                :key="childColumn.ex.id"
                v-bind="childColumn"
                :tree-node="indexTreeNode ? false : childColumn.ex.treeNode"
                :formatter="childColumn.ex.formatter">
              <template #header>
                <template v-if="childColumn.required">
                  <span class="required-icon">*</span>
                </template>
                <template v-if="childColumn.ex.header.slot">
                  <slot :name="childColumn.ex.header.slotField"></slot>
                </template>
                <template v-else>
                  <span>{{childColumn.header}}</span>
                </template>
                <template v-if="childColumn.help">
                  <gj-help class="gj-help">
                    {{childColumn.help}}
                  </gj-help>
                </template>
              </template>
              <template v-slot:default="{ $rowIndex, row }">
                <!-- slot -->
                <template v-if="childColumn.ex.slot">
                  <slot :name="childColumn.ex.slotField" :index="$rowIndex" :row="row"></slot>
                </template>
                <!-- option -->
                <template v-else-if="childColumn.ex.option">
                  <template v-if="optionText(row[childColumn.ex.originField], childColumn.options)">
                    <template v-if="childColumn.ex.optionBadge">
                      <gj-badge
                          status
                          :color="row[childColumn.ex.originField] | optionColor(childColumn.options)">
                        {{row[childColumn.ex.originField] | optionText(childColumn.options) | proxyDefaultShow(childColumn.defaultShow)}}
                      </gj-badge>
                    </template>
                    <template v-else-if="childColumn.ex.optionTag">
                      <gj-tag
                          shape="rectangle"
                          :color="row[childColumn.ex.originField] | optionColor(childColumn.options)">
                        {{row[childColumn.ex.originField] | optionText(childColumn.options)}}
                      </gj-tag>
                    </template>
                    <template v-else-if="childColumn.ex.optionPlain">
                      <gj-tag
                          v-if="optionColor(row[childColumn.ex.originField], childColumn.options)"
                          type="text"
                          :color="row[childColumn.ex.originField] | optionColor(childColumn.options)">
                        {{row[childColumn.ex.originField] | optionText(childColumn.options)}}
                      </gj-tag>
                      <template v-else>{{row[childColumn.ex.originField] | optionText(childColumn.options)}}</template>
                    </template>
                    <template v-else>
                      {{ row[childColumn.ex.originField] | optionText(childColumn.options) | proxyDefaultShow(childColumn.defaultShow, row) }}
                    </template>
                  </template>
                  <template v-else>{{ null | proxyDefaultShow(childColumn.defaultShow, row) }}</template>
                </template>
                <!-- picture -->
                <template v-else-if="childColumn.ex.picture">
                  <gj-image :src="row[childColumn.ex.originField]"></gj-image>
                </template>
                <!-- prefix、suffix -->
                <template v-else-if="childColumn.prefix || childColumn.suffix">
                  <template v-if="childColumn.prefix === 'currencySymbol' || childColumn.amount">
                    {{ row[childColumn.field] | scale(childColumn) | amount | valConcat(row, childColumn.prefix, childColumn.suffix) | proxyDefaultShow(childColumn.defaultShow) }}
                  </template>
                  <template v-else>
                    {{ row[childColumn.field] | scale(childColumn) | valConcat(row, childColumn.prefix, childColumn.suffix) | proxyDefaultShow(childColumn.defaultShow) }}
                  </template>
                </template>
                <!-- default format -->
                <template v-else>
                  {{ (childColumn.formatter || formatter)(row, childColumn) }}
                </template>
                <!-- copy -->
                <template v-if="childColumn.copyable">
                  <span v-copy="row[childColumn.ex.originField]"
                        class="copy-icon gj-cell-display-switch">
                    <gj-icon class="el-icon-copy-document"></gj-icon>
                  </span>
                </template>
              </template>
            </vxe-table-column>
          </template>
        </vxe-table-colgroup>
        <vxe-table-column
            v-else-if="column.ex.col"
            :key="column.ex.id"
            :tree-node="indexTreeNode ? false : column.ex.treeNode"
            v-bind="column">
          <template #header>
            <template v-if="column.required">
              <span class="required-icon">*</span>
            </template>
            <template v-if="column.ex.header.slot">
              <slot :name="column.ex.header.slotField"></slot>
            </template>
            <template v-else>
              <span>{{column.header}}</span>
            </template>
            <template v-if="column.helpObj">
              <gj-help class="gj-help">
                <div class="help-content">
                  <div v-if="column.helpObj.help">
                    <span>字段注释：</span>
                    <span>{{ column.helpObj.help }}</span>
                  </div>
                  <div v-if="column.helpObj.source">
                    <span>数据来源：</span>
                    <span>{{ column.helpObj.source }}</span>
                  </div>
                  <div v-if="column.helpObj.formula">
                    <span>计算公式：</span>
                    <span>{{ column.helpObj.formula }}</span>
                  </div>
                  <div v-if="column.helpObj.date">
                    <span>更新时间：</span>
                    <span>{{ updatedDate[column.helpObj.date] }}</span>
                  </div>
                  <div v-if="column.helpObj.instructions">
                    <span>使用说明：</span>
                    <span>{{ column.helpObj.instructions }}</span>
                  </div>
                </div>
              </gj-help>
            </template>
            <template v-else-if="column.help">
              <gj-help class="gj-help">
                {{column.help}}
              </gj-help>
            </template>
            <template v-if="column.helpHtml">
              <gj-help class="gj-help">
                <span v-html="column.helpHtml"></span>
              </gj-help>
            </template>
          </template>
          <template v-slot:default="{ $rowIndex, row }">
            <el-row
                :type="column.copyable ? 'flex' : null"
                align="middle">
              <div>
                <!-- expendRow -->
                <template v-if="extendRowConfig && row.$gjExtendRow">
                  <slot :name="'extend:row'" :index="$rowIndex" :row="row"></slot>
                </template>
                <!-- slot -->
                <template v-else-if="column.ex.slot">
                  <slot :name="column.ex.slotField" :index="$rowIndex" :row="row"></slot>
                </template>
                <!-- option -->
                <template v-else-if="column.ex.option">
                  <template v-if="optionText(row[column.ex.originField], column.options)">
                    <template v-if="column.ex.optionBadge">
                      <gj-badge
                          status
                          :color="row[column.ex.originField] | optionColor(column.options)">
                        {{row[column.ex.originField] | optionText(column.options) | proxyDefaultShow(column.defaultShow)}}
                      </gj-badge>
                    </template>
                    <template v-else-if="column.ex.optionTag">
                      <gj-tag
                          :color="row[column.ex.originField] | optionColor(column.options)">
                        {{row[column.ex.originField] | optionText(column.options)}}
                      </gj-tag>
                    </template>
                    <template v-else-if="column.ex.optionPlain">
                      <gj-tag
                          v-if="optionColor(row[column.ex.originField], column.options)"
                          type="text"
                          :color="row[column.ex.originField] | optionColor(column.options)">
                        {{row[column.ex.originField] | optionText(column.options)}}
                      </gj-tag>
                      <template v-else>{{row[column.ex.originField] | optionText(column.options)}}</template>
                    </template>
                    <template v-else>
                      {{ row[column.ex.originField] | optionText(column.options) | proxyDefaultShow(column.defaultShow, row) }}
                    </template>
                  </template>
                  <template v-else>{{ null | proxyDefaultShow(column.defaultShow, row) }}</template>
                </template>
                <!-- picture -->
                <template v-else-if="column.ex.picture">
                  <gj-image :src="row[column.ex.originField]"></gj-image>
                </template>
                <!-- prefix、suffix -->
                <template v-else-if="column.prefix || column.suffix">
                  <template v-if="column.prefix === 'currencySymbol' || column.amount">
                    {{ row[column.field] | scale(column) | amount | valConcat(row, column.prefix, column.suffix) | proxyDefaultShow(column.defaultShow) }}
                  </template>
                  <template v-else>
                    {{ row[column.field] | scale(column) | valConcat(row, column.prefix, column.suffix) | proxyDefaultShow(column.defaultShow) }}
                  </template>
                </template>
                <!-- default format -->
                <template v-else>
                  <template v-if="column.overflowLine">
                    <gj-tooltip
                        :text-line="column.overflowLine"
                        :content="(column.formatter || formatter)(row, column)"
                        style="display: inline-flex;">
                      {{ (column.formatter || formatter)(row, column) }}
                    </gj-tooltip>
                  </template>
                  <template v-else>
                    {{ (column.formatter || formatter)(row, column) }}
                  </template>
                </template>
              </div>
              <!-- copy -->
              <template v-if="column.copyable">
                <span v-if="row[column.ex.originField]"
                      v-copy="row[column.ex.originField]"
                      class="copy-icon gj-cell-display-switch">
                  <gj-icon class="el-icon-copy-document"></gj-icon>
                </span>
              </template>
              <!-- 动态组件 -->
              <template v-if="column.ex.activeComp">
                  <component
                  :is="column.activeComp"
                  :row="row"
                  ></component>
              </template>
            </el-row>
          </template>
        </vxe-table-column>

      </template>
      <template #empty>
        <slot name="empty">
          <div v-if="!loading"
               class="gj-empty__wrapper">
            <gj-empty></gj-empty>
          </div>
        </slot>
      </template>
    </vxe-table>
    <div class="gj-footer-content" v-if="$slots.footer">
      <slot name="footer"></slot>
    </div>
    <div v-if="hasPagination"
         :class="paginationClass">
      <slot name="pagination">
        <gj-pagination
            v-bind="paginationOption"
            :current-page.sync="pagination.currentPage"
            :page-size.sync="pagination.pageSize"
            :page-sizes="pageSizes"
            :total="pagination.total"
            :layout="layout"
            @size-change="pageChange"
            @current-change="pageChange('page')"
            @prev-click="pageChange('page')"
            @next-click="pageChange('page')"
        ></gj-pagination>
      </slot>
    </div>
  </div>
   </div>
</template>

<script>
  // import Sortable from 'sortablejs'
  import _ from 'lodash'
  import { performanceMixin } from "@/components/table/gj-table/config/performance";
  import { spanMixin } from "@/components/table/gj-table/config/span";
  import { columnsMixin } from "@/components/table/gj-table/config/columns";
  import testimg from '@/components/image/testimg.vue'

  import TableTab from './gj-table-tab.vue';
  import GjPagination from "../pagination/gj-pagination";
  import { defaultVal, isMeaningful, isMeaningless, isNumber, sumField, toFixed } from "../../utils/common";
  import { amount, optionColor, optionText, valConcat } from "../../filters";

  const gjExpandState = {
    waitExpand: 0,
    expanding: 1,
    expanded: 2,
  };

  export default {
    name: "gj-table",
    components: {
      GjPagination,
      testimg,
      TableTab
    },
    mixins: [ performanceMixin, columnsMixin, spanMixin, ],
    props: {
      pageSizes:{
        type:Array,
        default: () => [20, 50, 100, 200],
      },
      scrollY:{
        type:Object,
        default:()=>{
          return {mode: 'wheel', oSize:20}
        }
      },
      //分页配置
      layout:null,
      name: null,
      tableType: {
        type: String,
        default: "" // static: 前端静态分页
      },
      loading: {
        type: Boolean,
        default: false
      },
      showOverflow: {
        type: Boolean,
        default: true
      },
      showHeaderOverflow: {
        type: Boolean,
        default: false
      },
      showFooterOverflow: {
        type: Boolean,
        default: false
      },
      highlightHoverRow: {
        type: Boolean,
        default: true
      },
      data: {
        type: Array,
        default: () => [],
      },
      selectProp: {
        default: 'id',
      },
      stripe: {
        type: Boolean,
        default: false
      },
      autoResize: {
        type: Boolean,
        default: true
      },
      syncResize: {
        type: Boolean,
        default: true
      },
      adaptHeight: {
        type: Boolean,
        default: true
      },
      isMaxHeight: {
        type: Boolean,
        default: false
      },
      maxHeight: {
        type: Number,
        default: 0
      },
      /**
       * 虚拟滚动模式 wheel和default模式
       * @see {@link https://x-extends.github.io/vxe-table/#/table/scroll/mode 滚动模式}
       */
      modeScroll:{
        type:String,
        default:'wheel'
      },
      border: {
        type: [String, Boolean],
        default: 'default'
      },
      offsetTo: {
        type: String,
        default: 'window',
        validator: function (value) {
          return ['window', 'parent'].indexOf(value) !== -1
        }
      },
      offsetHeight: {
        type: Number,
        default: 10
      },
      defaultSort: {
        type: Object,
        default: null
      },
      size: {
        type: String,
        default: 'default',
        validator: function (value) {
          return ['single-line', 'default', 'has-picture', 'three-line'].indexOf(value) !== -1
        }
      },
      selection: {
        type: Boolean,
        default: false
      },
      // draggable: {
      //   type: Boolean,
      //   default: false,
      // },
      selectable: {
        type: Function
      },
      treeConfig: {
        type: Object,
        default: null
      },
      // {type: 'ParentChild' || 'ParentChildTree', children: 'children', parentSpan: [], spanType: 'col' | 'row' = 'col' }
      structureConfig: {
        type: Object,
        default: null
      },
      index: {
        type: Boolean,
        default: true
      },
      indexText: {
        type: String,
        default: '序号'
      },
      indexTreeNode: {
        type: Boolean,
        default: false
      },
      showSummary: {
        type: Boolean,
        default: false
      },
      pagination: {
        type: Object,
        default: null
      },
      isMinHeight: {
        type: Boolean,
        default: true
      },
      height: {
        type: Number,
        default: null
      },
      expand: {
        type: Boolean,
        default: false
      },
      expandLazyLoad: {
        type: Function,
        default: null
      },
      expandSeizeSeat: {
        type: Boolean,
        default: false
      },
      expandTableAttrs: {
        type: Object,
        default: () => {}
      },
      paginationOption: {
        type: Object,
        default: () => {}
      },
      // 临时解决方案，需要更改所有表格--zero
      minHeight: {
        type: Number,
        default: 150
      },
      adaptHeightListenUpdate: {
        type: Boolean,
        default: true
      },
      summaryObject: {
        default: null
      },
      highlightCurrentRow:{
        type:Boolean,
        default:false
      },
      childSelection:{
        type:Boolean,
        default:false
      },
      bakSelectedRows:{
        type:Array,
        default:()=>{
          return []
        }
      },
      bakRows:{
        type:Array,
        default:()=>{
          return []
        }
      },
      adaptParent: {
        /*
          开启此参数后将自动适应父元素的高度
          base-main中提供parentTable（开启后为标准表格界面）
          在未使用base-main的情况下，可给表格的父级div添加 .gj-table-parent_flex
        */
        type: Boolean,
        default: false
      },
      // 有校验错误的高度
      errorColumn: {
        type:Boolean,
        default:false
      },
      // 更新时间
      updatedDate: {
        type: Object,
        default: () => ({})
      }
    },
    filters: {
      scale(value, column) {
        if (isMeaningful(column.scale)) {
          return scaleFormat(value, column);
        }
        return value;
      },
      proxyDefaultShow(value, defaultValue, row) {
        if (isMeaningless(value) && typeof defaultValue === 'function' && isMeaningful(row)) {
          return defaultValue(row);
        }
        let v = '-';
        if (defaultValue !== null && defaultValue !== undefined) {
          v = defaultValue;
        }
        return defaultVal(value, v);
      }
    },
    created() {
      this.tableHeight = this.height;
      this.handleSlots(this.columns)
    },
    data() {
      return {
        adaptedHeight: null,
        tableHeight: null,
        tableMaxHeight: null,
        tableData: [],
        gjExpandState: gjExpandState,
        slotGroup: [],
        hasTab: this.columns.some(v => v.group),
      }
    },
    watch: {
      data: {
        handler: function (data, oldData) {
          this.dataProcessing(data);
          if (this.expand && data !== oldData) {
            this.tableData.forEach(item => this.$set(item, '$gjExpandState', gjExpandState.waitExpand));
          }
          // this.$refs?.tab?.handleChange();
        },
        immediate: true,
        deep: true
      },
      columns : {
        handler(val){
          this.handleSlots(val)
          // this.$refs?.tab?.handleChange();
        },
        immediate:true
      },
      summaryObject: {
        handler: function (data) {
          data && this.$refs.gjTable && this.$refs.gjTable.updateFooter()
        },
        immediate: true
      },
    },
    computed: {
      // 为了解决表格高度未重新计算
      tableHeightChage() {
        return this.$store.state.ad.tableHeight
      },
      parentChildStructure() {
        return isMeaningful(this.structureConfig)
          && (this.structureConfig.type === 'ParentChild' || this.structureConfig.type === 'ParentChildTree');
      },
      parentChildTreeStructure() {
        return isMeaningful(this.structureConfig)
          && this.structureConfig.type === 'ParentChildTree';
      },
      proxyTreeConfig() {
        if (isMeaningful(this.treeConfig)) {
          return {
            ...this.treeConfig,
            iconOpen: 'el-icon-arrow-down',
            iconClose: 'el-icon-arrow-right',
            iconLoaded: 'el-icon-loading'
          }
        }
        return null;
      },
      flatColumns() {
        return this._.flatMap(this.columns, (column) => {
          return isMeaningful(column.children) ? column.children : column
        });
      },
      // 是否服务器排序
      remote() {
        return this.tableType !== "static";
      },
      proxyDefaultSort() {
        if (this.defaultSort) {
          return {
            field: this.defaultSort.prop,
            order: (this.defaultSort.order || 'descending').replace('ending', '')
          }
        }
        return null;
      },
      hasPagination() {
        return this.pagination && this.data && this.data.length > 0;
      },
      showAllCheckbox() {
        if (this.selectable) {
          return this.data.some(item => this.selectable(item));
        }
        return true;
      },
      proxyBorder() {
        // 不等于默认值，则为使用者设置了新值
        if (this.border !== 'default') {
          return this.border;
        }
        if (this.columns.some(column => isMeaningful(column.children))) {
          return 'full';
        }
        return this.border;
      },
      paginationClass() {
        const clazz = ['footer__pagination'];
        // gj-table上只写属性border，则border为空字符串
        // 由于这种情况表格会加边框，所以分页也要加边框
        if (this.border === '') {
          clazz.push('border');
        }
        return clazz;
      },
      // 新增自适应表格高度
      pTableHeight() {
        if (this.adaptParent) {
          let height = '100%';
          let decreasePix = 0;
          if (this.hasPagination) decreasePix += 48;
          if (this.$slots.footer) decreasePix += 41;
          if (this.hasTab) decreasePix += 20;
          return `calc(${height} - ${decreasePix}px)`
        } else {
          return `${this.adaptedHeight}px`
        }
      },
      pVxeHeight() {
        if (this.adaptParent) {
          return !!this.tableHeight ? this.tableHeight : 'auto'
        }else{
          return this.tableHeight;
        }
      }

    },
    methods: {
      //高亮点击行
      currentChange(val){
        this.$emit('currentChange',val.row)
      },
      // data处理
      dataProcessing(data) {
        let dataMap = [...data];
        if (this.tableType === 'static') {
          dataMap = this.dataSection(data, this.pagination);
          this.$emit('static-page-change', dataMap);
        }
        this.tableData = this.mapTableData(dataMap);
        if (this.$refs && this.$refs.gjTable && this.$refs.gjTable.bodyWrapper) {
          this.$refs.gjTable.bodyWrapper.scrollLeft = 0;
        }

        // 树形表格处理
        if (isMeaningful(this.proxyTreeConfig)) {
          // 默认展开所有
          if ('expandAll' in this.proxyTreeConfig && this.$refs.gjTable) {
            this.$nextTick(() => {
              this.$refs.gjTable && this.$refs.gjTable.setAllTreeExpand(true);
            });
          }
        }
        this.selectionChange({ checked: true, records: []});
      },
      // 分页控制
      pageChange(page) {
        // 存储分页缓存
        if (this.tableType === "static") {
          this.dataProcessing(this.data);
          return;
        }
        this.$emit('page-change', page);
      },
      // data切片 用在前端分页上
      dataSection(data = [], pagination = {}) {
        let index = 0;
        let dataMap = data.reduce((arr, item) => {
          arr[index] && arr[index].length >= pagination.pageSize && index++;
          arr[index] = arr[index] || [];
          arr[index].push(item);
          return arr
        }, []);
        if (!dataMap[pagination.currentPage - 1]) {
          return dataMap[dataMap.length - 1]
        }
        return dataMap[pagination.currentPage - 1]
      },
      isMeaningless(value) {
        return isMeaningless(value);
      },
      isMeaningful(value) {
        return isMeaningful(value);
      },
      optionText(id, options) {
        return optionText(id, options);
      },
      optionColor(id, options) {
        return optionColor(id, options);
      },
      mapTableData(data) {
        if (this.parentChildStructure) {
          let tableData = [];
          const spanType = this.structureConfig['spanType'] ? this.structureConfig['spanType'] : 'col';
          data.forEach((item, index) => {
            item.$gjDataType = '$gjParentData';
            item.$gjParentData = true;
            const childData = item[this.structureConfig.children] || [];
            if (spanType === 'col') {
              tableData.push(item);
              childData.forEach((childItem, childIndex) => {
                childItem.$gjChildData = true;
                childItem.$gjParentIndex = index;
                childItem.$gjChildIndex = childIndex;
              });
              tableData = tableData.concat(childData);
              if (this.extendRowConfig && item[this.extendRowConfig.prop]) {
                tableData.push({
                  ...item,
                  $gjExtendRow: true,
                  $gjExtendRowAlias: true
                });
                item['$gjExtendRowAlias'] = false;
              }
            } else if (spanType === 'row') {
              if (childData.length > 0) {
                const parentItem = {
                  ...item,
                  ...childData[0],
                  $gjChildItemLength: childData.length,
                  $gjParentIndex: index,
                  $gjChildIndex: 0
                };
                tableData.push(parentItem);
                const expandChildItems = !this.parentChildTreeStructure || this.structureConfig['expand'];
                if (expandChildItems) {
                  parentItem.$gjExpandState = gjExpandState.expanded;
                  parentItem.$gjRowSpan = parentItem.$gjChildItemLength;
                  childData.forEach((childItem, childIndex) => {
                    if (childIndex > 0) {
                      childItem.$gjChildData = true;
                      childItem.$gjParentIndex = index;
                      childItem.$gjChildIndex = childIndex;
                      tableData.push(childItem);
                    }
                  });
                } else {
                  parentItem.$gjRowSpan = 1;
                  parentItem.$gjExpandState = gjExpandState.waitExpand;
                }
              }
            }
          });
          return tableData;
        }
        return data || [];
      },
      setCurrentRow(data) {
        this.$refs.gjTable.setCurrentRow(data);
      },
      setHeight(height) {
        // 新增自适应父元素高度
        if (this.adaptParent) {
          this.adaptedHeight = null
          this.tableHeight = null
          return
        }
        if (this.minHeight && this.adaptedHeight === this.minHeight) {
          return;
        }
        if (this.adaptHeight && height !== this.adaptedHeight) {
          this.adaptedHeight = height - this.offsetHeight - 22 -(this.hasTab ? 20 : 0);
          if (this.minHeight && this.adaptedHeight < this.minHeight) {
            this.adaptedHeight = this.minHeight;
          }
          const h = `${this.adaptedHeight - (this.pagination ? 40 : 0) - (this.$slots.footer ? 40 : 0)}`;
          this.tableMaxHeight = this.isMinHeight ? null : h;
          this.tableHeight = this.isMinHeight ? h : null;
        }
        if(!this.adaptHeight && this.isMaxHeight){
          this.tableMaxHeight = this.maxHeight
        }
      },
      selectionChange(obj) {
        if (this.parentChildStructure && this.childSelection){
          return this.parentToggleChecked(obj.row, obj.checked, obj);
        }
        if(this.bakSelectedRows.length > 0){    // 点击了扩展行更多 取已勾选的数据
           obj.records = this.bakRows;
           this.$emit('clearBakSelectedRows');
        }
        this.$emit('selection-change', obj.records);
        this.$emit('selection-prop-change', obj.records.map(e => e[this.selectProp]));
      },
      parentToggleChecked(row,checked,obj){
        let key = this.structureConfig.children;
        const $table = this.$refs.gjTable
        let childRecords = [];
        //  点击父勾选 -- 切换子数据    ---  row.productsCopy 所有数据     row[key] 显示的数据
        row && row.$gjParentData && row.productsCopy && row.productsCopy.forEach(item => {
          $table.setCheckboxRow(item, checked);
          childRecords.push(item);
        });
        // 点击 子勾选
        if(row && row.$gjChildData){
          childRecords.push(row);
          let findParentItem = obj.data.find(item=> item.$gjParentKey === row.$gjChildKey && item.$gjParentData);
          let findSameChild =  this.bakRows.filter(item => item.$gjChildKey === row.$gjChildKey && item.$gjChildData)
          if(checked){ // 选中
               if(findParentItem.num === 1){  // 子数据只有一条的时候
                 $table.setCheckboxRow(findParentItem, true);
               }else if(findSameChild.length + 1 === findParentItem.num){    // 找到的条数+1 等于 所有的子条数的时候
                 $table.setCheckboxRow(findParentItem, true);
               }else{
                 // 半选
               }
          }else{
              if(findParentItem.num === 1){
                $table.setCheckboxRow(findParentItem, false);
              }else if(findSameChild.length -1 <= findParentItem.num){
                $table.setCheckboxRow(findParentItem, false);
              }else{
                // 半选状态
                $table.setCheckboxRow(findParentItem, false);
              }
            }
        }
         // 勾选父数据 展开列表
        if(row && row.$gjParentData && checked){
          this.$nextTick(()=>{
            this.$emit('openDetail',row, true);
          })
        }
        if(this.bakSelectedRows.length > 0){    // 点击了扩展行
          obj.records = this.bakRows;
          $table.setCheckboxRow(obj.records, true);
        }
        if(childRecords.length > 0 && obj.checked){   // 勾选时
          obj.records = this._.unionWith(this.bakRows, childRecords, this._.isEqual);
        }else if(childRecords.length > 0 && !obj.checked){   // 取消勾选时
          obj.records =  this._.differenceWith(this.bakRows, childRecords, this._.isEqual)
        }
        this.$emit('selection-change', obj.records.filter(v => v.$gjChildData));
        this.$emit('selection-prop-change', obj.records.map(e => e[this.selectProp]));
        this.$emit('clearBakSelectedRows');

        return false;
      },
      formatter(row, column) {
        const value = row[column.property || column.field];
        if (isMeaningful(column.scale)) {
          return scaleFormat(value, column);
        }
        let v = '-';
        if (column.defaultShow !== null && column.defaultShow !== undefined) {
          v = column.defaultShow;
        }
        return defaultVal(value, v);
      },
      cellMouseEnter(row, column, cell, event) {
        cell.parentElement.classList.add('gj-table-hover-row');
      },
      cellMouseLeave(row, column, cell, event) {
        cell.parentElement.classList.remove('gj-table-hover-row');
      },
      expandRow(expand, row, index) {
        if (expand) {
          if (!row.$gjChildExpandRow) {
            if (this.expandLazyLoad) {
              const vm = this;
              const resolve = (childData) => {
                const $gjExpandRow = {$gjExpandRow: true};
                row.$gjChildExpandRow = $gjExpandRow;
                vm.data.splice(index + 1, 0, $gjExpandRow);
                vm.$set(row, '$gjExpandState', gjExpandState.expanded);
                vm.$set(row.$gjChildExpandRow, '$gjExpandRowData', childData);
                vm.$set(row.$gjChildExpandRow, '$gjExpandState', gjExpandState.expanded);
              };
              this.expandLazyLoad(row, index, resolve);
              this.$set(row, '$gjExpandState', gjExpandState.expanding);
            } else {
              this.$set(row, '$gjExpandState', gjExpandState.expanded);
            }
          } else {
            this.$set(row, '$gjExpandState', gjExpandState.expanded);
            this.$set(row.$gjChildExpandRow, '$gjExpandState', gjExpandState.expanded);
          }
        } else {
          this.$set(row, '$gjExpandState', gjExpandState.waitExpand);
          this.$set(row.$gjChildExpandRow, '$gjExpandState', gjExpandState.waitExpand);
        }
      },
      parentChildExpandRow(expand, row, index) {
        let nextIndex = index + 1;
        const childData = row[this.structureConfig.children] || [];
        if (expand) {
          row.$gjRowSpan = row.$gjChildItemLength;
          row.$gjExpandState = gjExpandState.expanded;
          childData.forEach((childItem, childIndex) => {
            if (childIndex > 0) {
              childItem.$gjChildData = true;
              childItem.$gjParentIndex = index;
              childItem.$gjChildIndex = childIndex;
              this.tableData.splice(nextIndex, 0, childItem);
              nextIndex++;
            }
          });
        } else {
          row.$gjRowSpan = 1;
          row.$gjExpandState = gjExpandState.waitExpand;
          this.tableData.splice(nextIndex, row.$gjChildItemLength - 1);
        }
      },
      proxyRowClassName({row, rowIndex}) {
        let className = [];
        if (this.extendRowConfig && row['$gjExtendRowAlias']) {
          return 'gj-table-expend-row';
        }
        if (row.$gjExpandRow) {
          if (row.$gjExpandState === gjExpandState.waitExpand) {
            className.push('gj-table__row--wait-expand');
          } else if (row.$gjExpandState === gjExpandState.expanded) {
            className.push('gj-table__raw--expanded');
          }
        }
        if (row.$gjDataType === '$gjChildData') {
          className.push('gj-table__raw--child');
        }
        // 树形表格样式类设置，目前只会更改叶子节点的背景色
        if (isMeaningful(this.proxyTreeConfig)) {
          // 用于懒加载时添加用于标识的class，需要在懒加载获取数据方法loadMethod中，设置每一行数据的isTreeChild为true
          if(isMeaningful(row.isTreeChild)){
            return 'lazy-tree-child-row'
          }

          if ((isMeaningless(row[this.proxyTreeConfig.children]) || row[this.proxyTreeConfig.children].length === 0)
            && !row[this.proxyTreeConfig.parent]) {
            return 'tree-table__child--row'
          }
        }
        // 父子表格
        if (this.parentChildStructure) {
          if (row.$gjParentData) {
            const spanType = this.structureConfig['spanType'] ? this.structureConfig['spanType'] : 'col';
            if (spanType === 'col') {
              return 'gj-table-parent-row';
            }
          }
        }
        if (this.$attrs['row-class-name']) {
          className.push(this.$attrs['row-class-name']({row, rowIndex}));
        }
        return className.join(' ');
      },
      proxySummaryMethod({columns, data}) {
        if (this.$attrs['summary-method']) {
          return [this.$attrs['summary-method']({columns, data})];
        }
        const exColumns = [];
        if (this.index) {
          exColumns.push({});
        }
        if (this.selection) {
          exColumns.push({});
        }
        if (this.expand) {
          exColumns.push({});
        }
        const summary = exColumns.concat(this.flatColumns.filter(column => this.permissionShow(column) && (isMeaningless(column.exist) || column.exist))).map((column, index) => {
          if (index === 0) {
            return '总计';
          } else {
            if (column.summary) {
              // 自定义保留小数位
              const scale = isMeaningful(column.scale) ? column.scale : 2;
              if (this.summaryObject) {
                let value = this.summaryObject[this.originField(column.field)];

                if (isMeaningful(value) && isMeaningful(column.prefix) && column.prefix.toLowerCase().includes('currencysymbol')) {
                  value = amount(value, scale);
                }

                return valConcat(value, data[0], column.prefix, column.suffix);
              }
              let summary = null;
              // 自定义合计方法
              let summaryBy = column.field;
              if (isMeaningful(column.summaryBy)) {
                summaryBy = column.summaryBy;
              } else if (this.decorated(column.field, '')) {
                summaryBy = this.originField(column.field);
              }
              if (column.summaryMethod) {
                summary = column.summaryMethod(data, summaryBy);
              } else if (typeof column.summary === 'string'
                && (this.decorated(column.summary, 'percent') || this.decorated(column.summary, 'ratio'))) {
                const expression = this.originField(column.summary);
                const tmp = expression.split('/');
                // 多列合计
                const a = sumField(data, tmp[0], scale);
                const b = sumField(data, tmp[1], scale);
                if (b === 0) {
                  return '-';
                }
                if (this.decorated(column.summary, 'percent')) {
                  return `${toFixed(a / b * 100, scale)}%`;
                } else if (this.decorated(column.summary, 'ratio')) {
                  let result = toFixed(a / b, scale);
                  if (isMeaningful(column.prefix) || isMeaningful(column.suffix)) {
                    if (isMeaningful(result) && isMeaningful(column.prefix) && column.prefix.toLowerCase().includes('currencysymbol')) {
                      result = amount(result, 2);
                    }
                    return valConcat(result, data[0], column.prefix, column.suffix)
                  }
                  return result;
                } else {
                  return '-';
                }
              } else {
                // 默认单列合计方法
                summary = sumField(data, summaryBy, scale);
              }
              if (isMeaningful(data) && data.length > 0) {
                if (isMeaningful(summary) && isMeaningful(column.prefix) && column.prefix.toLowerCase().includes('currencysymbol')) {
                  summary = amount(summary, 2);
                }
                return valConcat(summary, data[0], column.prefix, column.suffix);
              }
              return summary;
            }
              if (column.summaryAbs) {
                  let summary = null;
                  // 自定义保留小数位
                  const scale = isMeaningful(column.scale) ? column.scale : 2;
                  // 自定义合计方法
                  let summaryBy = column.field;
                  if (isMeaningful(column.summaryBy)) {
                      summaryBy = column.summaryBy;
                  } else if (this.decorated(column.field, '')) {
                      summaryBy = this.originField(column.field);
                  }
                  if (column.summaryMethod) {
                      summary = column.summaryMethod(data, summaryBy);
                  } else if (typeof column.summaryAbs === 'string' && (this.decorated(column.summaryAbs, 'percent') || this.decorated(column.summaryAbs, 'ratio'))) {
                      const expression = this.originField(column.summaryAbs);
                      const tmp = expression.split('/');
                      // 多列合计
                      const a = sumField(data, tmp[0], scale);
                      const b = sumField(data, tmp[1], scale);
                      if (b === 0) {
                          return '-';
                      }
                      if (this.decorated(column.summaryAbs, 'percent')) {
                          return `${toFixed(Math.abs(a / b * 100), scale)}%`;
                      } else if (this.decorated(column.summaryAbs, 'ratio')) {
                          let result = toFixed(Math.abs(a / b), scale);
                          if (isMeaningful(column.prefix) || isMeaningful(column.suffix)) {
                              if (isMeaningful(result) && isMeaningful(column.prefix) && column.prefix.toLowerCase().includes('currencysymbol')) {
                                  result = amount(result, 2);
                              }
                              return valConcat(result, data[0], column.prefix, column.suffix)
                          }
                          return result;
                      } else {
                          return '-';
                      }
                  } else {
                      // 默认单列合计方法
                      summary = Math.abs(sumField(data, summaryBy, scale));
                  }
                  if (isMeaningful(data) && data.length > 0) {
                      if (isMeaningful(summary) && isMeaningful(column.prefix) && column.prefix.toLowerCase().includes('currencysymbol')) {
                          summary = amount(summary, 2);
                      }
                      return valConcat(summary, data[0], column.prefix, column.suffix);
                  }
                  return summary;
              }
            return '';
          }
        });
        return [summary];
      },
      checkMethod({ row }) {
        if (this.selectable) {
          return this.selectable(row);
        }
        return true;
      },
      // columnDrag () {
      //   this.$nextTick(() => {
      //     let xTable = this.$refs.gjTable;
      //     this.sortable = Sortable.create(xTable.$el.querySelector('.body--wrapper>.vxe-table--header .vxe-header--row'), {
      //       handle: '.vxe-header--column:not(.col--fixed)',
      //       onEnd: ({ item, newIndex, oldIndex }) => {
      //         let { fullColumn, tableColumn } = xTable.getTableColumn()
      //         let targetThElem = item
      //         let wrapperElem = targetThElem.parentNode
      //         let newColumn = fullColumn[newIndex]
      //         if (newColumn.fixed) {
      //           // 错误的移动
      //           if (newIndex > oldIndex) {
      //             wrapperElem.insertBefore(targetThElem, wrapperElem.children[oldIndex])
      //           } else {
      //             wrapperElem.insertBefore(wrapperElem.children[oldIndex], targetThElem)
      //           }
      //           return this.$gjMessage.error({ message: '固定列不允许拖动！', status: 'error' })
      //         }
      //         // 转换真实索引
      //         let oldColumnIndex = xTable.getColumnIndex(tableColumn[oldIndex])
      //         let newColumnIndex = xTable.getColumnIndex(tableColumn[newIndex])
      //         // 移动到目标列
      //         let currRow = fullColumn.splice(oldColumnIndex, 1)[0]
      //         fullColumn.splice(newColumnIndex, 0, currRow)
      //         xTable.loadColumn(fullColumn)
      //       }
      //     })
      //   })
      // },
      disableFixedLeftScroll() {
        if (this.$refs.gjTable && this.$refs.gjTable.$refs) {
          const leftBody = this.$refs.gjTable.$refs.leftBody;
          if (isMeaningful(leftBody)) {
            leftBody.$el.onscroll = () => {
              if (leftBody.$el.scrollLeft !== 0) {
                leftBody.$el.scrollLeft = 0;
              }
            };
          }
        }
      },
      // 处理分组列的插槽
      handleSlots(columns) {
        const groups = columns.filter(v=>v.group);
        this.slotGroup =  _.uniq(groups.map(g => {
          return g.group.id;
          // 虽然比较难取，但依然照旧，不新增配置字段
        })).map(f => 'header:' + columns.find(i => i.id === f).header.split(':')[1]);
      },
      // 表格滚动
      handleTableScroll(e) {
        this.$refs.tab?.handleScroll(e);
      }

    },
    // mounted () {
    //   if (this.draggable) {
    //     this.columnDrag();
    //   }
    // },
    // beforeDestroy () {
    //   if (this.sortable) {
    //     this.sortable.destroy();
    //   }
    // },
  }

  function scaleFormat(value, column) {
    if (isMeaningful(value)
      && isNumber(value)) {
      return toFixed(value, column.scale);
    }
    return value;
  }
</script>

<style  scoped lang="scss">
@import '@/assets/styles/variables.scss';
::v-deep .vxe-table  .vxe-header--row {
  height: 40px !important;
  background-color: $gj-tableHeader-color;
}
::v-deep .vxe-table  .vxe-footer--row{
  background-color: $gj-tableHeader-color;
}
::v-deep tr.gj-table-parent-row:hover > td {
  background-color: $gj-tableFather-color!important;
}
.help-content {
  max-height: 167px;
  margin-right: -7px;
  padding-right: 7px;
  text-align: justify;
  overflow: auto;
  &::-webkit-scrollbar-track { 
    background-color: unset;  //设置背景透明
  }
  &::-webkit-scrollbar-thumb { //设置滑块
    background: $gj-scroll-background-color-hover;
  }
}

.gj-table {
  background-color: #fff;
  max-height: 100vh; // 防止表格无限加载
}
.wrapper-loading{
  height: 100%;
}
.gj-help {
  margin-left: 3px !important;
}

/* 字体大小 */
/deep/ .vxe-table.size--small {
  font-size: 12px;
}

/** 表格复选列-checkbox */
/deep/ .vxe-table .vxe-cell--checkbox .vxe-checkbox--icon:before {
  border: 1px solid #dcdfe6;
}

/************** 表头设置 ******************/

/deep/ .vxe-table.size--small .vxe-header--column {
  padding: 4px 0;
}
/* 表头行高，设置为1，垂直居中对齐; 字重 */
/deep/ .vxe-table .vxe-header--column {
  /*background: #fff!important;*/
  line-height: 1;
  font-weight: 600;
}
/* 垂直居中对齐 */
/deep/ .vxe-table .vxe-header--column .vxe-cell {
  display: flex;
  align-items: center;
}
/* 水平居中对齐 */
/deep/ .vxe-table .vxe-header--column.col--center .vxe-cell {
  justify-content: center;
}
/* 右对齐 */
/deep/ .vxe-table .vxe-header--column.col--right .vxe-cell {
  justify-content: flex-end;
}
/* 可排序表头单元格--手形图标 */
/deep/ .vxe-table .vxe-header--column.is--sortable {
  cursor: pointer;
}

/**************************** 表头设置结束 *************************/

/**************************** 表格高度设置开始 *************************/

/deep/ .vxe-table td.vxe-body--column {
  padding: 4px 0;
}

/** 单元格内容行高 */
/deep/ .vxe-table .vxe-body--column,
/deep/ .vxe-table .vxe-footer--column,
/deep/ .vxe-table .vxe-header--column {
  line-height: 16px;
}

.gj-table--single-line /deep/ td:not(.vxe-footer--column) {
  height: 38px;
}

.gj-table--default /deep/ td.vxe-body--column {
  height: 45px !important;
  box-sizing: content-box;
}
.error-column-height {
  .gj-table--default /deep/ td.vxe-body--column {
    height: 58px !important;
  }
  .gj-table--has-picture /deep/ td.vxe-body--column {
    height: 58px !important;
  }
}

.gj-table--has-picture /deep/ td.vxe-body--column {
  height: 54px !important;
}

.gj-table--three-line /deep/ td.vxe-body--column {
  height: 59px !important;
}

/deep/ .vxe-table .gj-table-expend-row td:not(.vxe-footer--column) {
  height: auto;
  background-color: #fff;
  // border-bottom: 1px solid #fff;
}

/deep/ .vxe-table .gj-table-expend-row td:not(.vxe-footer--column) .default {
  text-align: center;
  padding: 4px 0;
}

/deep/ .vxe-table .gj-table-expend-row td.vxe-body--column {
  padding: 0 !important;
}

/**************************** 表格高度设置结束 *************************/


/**************************** 表底部设置开始 *************************/

/deep/ .vxe-table td.vxe-footer--column {
  padding: 0 !important;
}

/deep/ .vxe-table td.vxe-footer--column {
  height: 40px;
}

/**************************** 表底部设置结束 *************************/

/**************************** 父子table结构设置结束 *************************/

/deep/ .gj-table-parent-row,
/deep/ tr.gj-table-parent-row:hover > td {
  background-color: $gj-tableFather-color !important;
}

/**************************** 父子table结构设置结束 *************************/



/**************************** 展开懒加载设置开始 *************************/

.gj-table__row--expand-icon {
  text-align: center;
  cursor: pointer;
}

/deep/ .el-pagination {
  font-weight: 500;
}

/deep/ .vxe-table .gj-table__row--wait-expand {
  display: none !important;
}

/deep/ .vxe-table .gj-table__raw--expanded .vxe-body--row  {
  background-color: #F6F7F8;
}

/deep/ .vxe-table .gj-table__raw--expanded > td,
/deep/ .vxe-table .gj-table__raw--expanded > td > .vxe-cell {
  padding: 0 !important;
}

.gj-table /deep/ .gj-table__raw--expanded .vxe-body--row:last-child td,
/deep/ .vxe-table .gj-table__raw--expanded .vxe-body--row:last-child td,
/deep/ .gj-table__raw--expanded > td {
  border-bottom: none;
}

/**************************** 展开懒加载设置结束 *************************/


/**************************** 空数据表格边框设置开始 *************************/

/deep/ .vxe-table.gj-table-empty:not(.border--full):not(.border--default) .vxe-table--border-line,
/deep/ .vxe-table.gj-table-no-pagination:not(.border--full):not(.border--default) .vxe-table--border-line {
  border: none;
}

/**************************** 空数据表格边框设置结束 *************************/

/**************************** 树形表格设置开始 *************************/

/deep/ .vxe-table .tree-table__child--row {
  // background-color: rgb(250,250,252);
}

/**************************** 树形表格设置结束 *************************/

/deep/ .vxe-table.gj-parent-child-table .is--disabled.vxe-cell--checkbox {
  display: none;
}

/* 分页样式 */
.footer__pagination {
  padding: 12px 0 0 0;
  text-align: right;
}

.footer__pagination.border {
  border: 1px solid #EBEEF5;
  border-top: none;
}

/* 空状态 */
/deep/ .vxe-table.is--empty .vxe-table--empty-placeholder {
  // padding-top: 10px;
  height: unset !important;
}
.gj-empty__wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}
.gj-empty {
  width: 200px;
  padding: 10px;
}
.gj-empty-description {
  line-height: normal;
  color: #C0C4CC;
  font-size: 14px;
}

.gj-table--sortable .vxe-header--row .vxe-header--column.sortable-ghost,
.gj-table--sortable .vxe-header--row .vxe-header--column.sortable-chosen {
  background-color: #dfecfb;
}

/* expand */
/deep/ .vxe-table .vxe-body--expanded-cell {
  padding: 0 0 0 50px;
}

/* 底部内容 */
.gj-footer-content {
  box-sizing: border-box;
  border: 1px solid #d8dadd;
  border-top: none;
  background-color: #F6F8FB;
  color: #333;
  font-size: 12px;
}

.gj-footer-content .default {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 20px;
  font-weight: bold;
}
/deep/ .col--last{
  .vxe-cell{
    padding-left: 16px;
  }
}
/deep/ .vxe-table--footer-wrapper{
  color: #333;
}
/deep/.gj-help--icon{
  .gj-icon{
    font-size: 13px;
    color: #666;
  }
}
/deep/ .vxe-table--border-line{
  border-color: #d8dadd !important;
}
/deep/ .vxe-table--render-default .vxe-table--footer-wrapper{
  background-color: #e8eaec;
}
/deep/ .vxe-table--render-default .vxe-table--fixed-left-wrapper.scrolling--middle {
  box-shadow: 4px 0px 6px -2px rgba($color: #000000, $alpha: 0.12);
}
/deep/ .vxe-table--render-default .vxe-table--fixed-right-wrapper.scrolling--middle{
  box-shadow: -4px 0 6px -2px rgba($color: #000000, $alpha: 0.12);
}

/deep/ .el-pagination.el-pagination--small{
  display: flex;
  align-items: center;
  justify-content: flex-end;
  .el-input__inner{
    height: 22px !important;
    line-height: 22px !important;
  }
  .el-input__icon{
    height: 22px;
    line-height: 22px;
  }
}
</style>

